import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ImportModal from "../../components/Modals/ImportModel";
import GenerateTicketsModal from "../../components/Modals/GenerateTicketsModal";
import AddLeadModal from "../../components/Modals/CreateLeadModel";
import AddTagModal from "../../components/Modals/AddTagModel";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { toast } from "react-toastify";
import debounce from "debounce";
import axios from "axios";
import ReactPaginate from "react-paginate";
import NoData from "../../components/NoData";
import ExportModal from "../../components/Modals/ExportsModel/main";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdLocationOn,
  MdMessage,
  MdPhone,
} from "react-icons/md";
import Loader from "../../components/Loader";
import {
  Card,
  Button,
  Dropdown,
  DropdownButton,
  Row,
  Col,
  Form,
  Accordion,
} from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPen,
  FaPlus,
  FaTrash,
  FaTrashAlt,
} from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import LeadViewModal from "../../components/Modals/LeadViewModel";
import moment from "moment";
import { useCommonContext } from "../../utils/context";
import { useTypeConfig } from "../../utils/useTypeConfig";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";

const STATUS_CHOICES = [
  { value: "Inactive", label: "Inactive" },
  { value: "Interact", label: "Interact" },

  { value: "In-Discussion", label: "In-Discussion" },

  { value: "Quote Sent", label: "Quote Sent" },

  { value: "Service Taken", label: "Service Taken" },
  { value: "Not Interested", label: "Not Interested" },
];

const DATE_FILTER_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "tomorrow", label: "Tomorrow" },
  { value: "yesterday", label: "Yesterday" },

  { value: "this week", label: "This Week" },

  { value: "this month", label: "This Month" },
  { value: "customrange", label: "Custom Range" },
];

const STATUS_COLORS = {
  "Not Interested": "#fdeaea",
  "In-Discussion": "#fff8e1",
  "Service Taken": "#e8f5e9",
  Inactive: "#f3f3f3",
  Interact: "#e3f2fd",
  "Quote Sent": "#e0f7fa",
};

const STATUS_BORDERS = {
  "Not Interested": "#dc3545",
  "In-Discussion": "#e0a800",
  "Service Taken": "#218838",
  Inactive: "#6c757d",
  Interact: "#0056b3",
  "Quote Sent": "#138496",
};
const LeadList = () => {
  const [showLeadModal, setShowLeadModal] = useState(false);
  const { labels, hiddenFields } = useTypeConfig();
  const location = useLocation();
  const [editLeadData, setEditLeadData] = useState(null);
  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [filteredLeadData, setFilteredLeadData] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const userPermissions = localStorage.getItem("user_permissions");

  const [leadDataCount, setLeadDataCount] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchLeadText, setSearchLeadText] = useState("");
  const [leadFilterStartDate, setLeadFilterStartDate] = useState("");
  const [leadFilterEndDate, setLeadFilterEndDate] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const { toggled } = useCommonContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredLeadData.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredLeadData.length / itemsPerPage);
  const [executiveFilter, setExecutiveFilter] = useState("");
  const [executives, setExecutives] = useState([]);
  const fetchExecutives = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/users/tms_users/executive/`,
        {
          headers: HEADERS,
        },
      );
      if (response && response.data) {
        setExecutives(response.data);
      }
    } catch (error) {}
  };

  const fetchAllLeadData = async () => {
    try {
      let url = `${BASE_URL}/api/leads/status_counts/`;

      const response = await axios.get(url, {
        headers: {
          ...HEADERS,
          "Content-Type": "application/json",
        },
      });

      if (response && response.data) {
        setLeadDataCount(response.data);
      }
    } catch (error) {}
  };

  const fetchLeadData = async (page = 1) => {
    setLoading(true);

    try {
      const queryParams = {
        page: page,
        page_size: itemsPerPage,
        status: statusFilter || undefined,
        search: searchLeadText || undefined,
        next_interaction: dateFilter || undefined,
        executive: executiveFilter || undefined,
      };

      if (dateFilter === "customrange") {
        if (leadFilterStartDate) {
          queryParams.start_date = leadFilterStartDate;
        }
        if (leadFilterEndDate) {
          queryParams.end_date = leadFilterEndDate;
        }
      }

      const searchParams = new URLSearchParams(location.search);

      const leadId = searchParams.get("lead_id");
      if (leadId) {
        queryParams.lead_id = leadId;
      }

      const response = await axios.get(`${BASE_URL}/api/leads/`, {
        headers: HEADERS,
        params: queryParams,
      });

      if (response && response.data) {
        setFilteredLeadData(response.data.results || []);
        setTotalPages(Math.ceil(response.data.total_pages));
        setCurrentPage(page);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchLeadData(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeadData();
  }, [location.search]);

  const getTotalCountByStatus = (status) => {
    return leadDataCount[status] || 0;
  };

  useEffect(() => {
    if (
      dateFilter !== "customrange" ||
      leadFilterEndDate ||
      leadFilterStartDate
    ) {
      fetchLeadData(currentPage);
      fetchAllLeadData();
    }
    fetchExecutives();
  }, [
    searchLeadText,
    statusFilter,
    dateFilter,
    leadFilterStartDate,

    leadFilterEndDate,
    itemsPerPage,
    currentPage,
    executiveFilter,
  ]);

  useEffect(() => {
    if (
      dateFilter !== "customrange" ||
      leadFilterEndDate ||
      leadFilterStartDate
    ) {
      setCurrentPage(1);
    }
  }, [
    searchLeadText,
    statusFilter,
    dateFilter,
    leadFilterEndDate,
    leadFilterStartDate,
  ]);

  const handleSearchTextChange = (e) => {
    setSearchLeadText(e.target.value);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCloseModals = () => {
    setShowLeadModal(false);
    setShowImportModal(false);
    setSelectedLead(null);
  };

  const handleViewLead = (lead) => {
    setSelectedLead(lead);
    setShowViewModal(true);
    setIsUpdateStatus(false);
  };

  const handleApplyLead = () => {
    setEditLeadData(null);
    setIsUpdateStatus(false);
    setShowLeadModal(true);
  };

  const handleEditLead = (lead) => {
    setEditLeadData(lead);
    setIsUpdateStatus(false);
    setShowLeadModal(true);
  };

  const handleUpdateStatus = (lead) => {
    setEditLeadData(lead);
    setIsUpdateStatus(true);
    setShowLeadModal(true);
  };

  const handleDeleteLead = async (lead) => {
    try {
      const response = await axios.delete(`${BASE_URL}/api/leads/${lead.id}`, {
        headers: {
          ...HEADERS,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        toast.success(response.data.message);
        fetchLeadData(currentPage);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 container-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-3 mb-md-0">Lead List</h4>
      </div>
      <div className="row mb-3 justify-content-center">
        {STATUS_CHOICES.map((item, index) => (
          <div
            key={index}
            className="col-12 col-sm-6 col-md-3 col-lg-2 mb-3 d-flex justify-content-center"
          >
            <Card
              className="shadow-sm"
              style={{
                backgroundColor: STATUS_COLORS[item.value],
                border: `1px solid ${STATUS_BORDERS[item.value]}`,
                borderRadius: "12px",
                minHeight: "60px",
                width: "100%",
                maxWidth: "190px",
                display: "flex",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <Card.Body className="d-flex justify-content-between align-items-center px-3">
                <h6
                  style={{
                    fontWeight: "600",
                    color: STATUS_BORDERS[item.value],
                    marginBottom: 0,
                    marginRight: "10px",
                    fontSize: "1rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </h6>
                <h4
                  style={{
                    fontWeight: "700",
                    marginBottom: 0,
                    fontSize: "1.25rem",
                  }}
                >
                  {getTotalCountByStatus(item.value)}
                </h4>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>

      <Row className="w-100 g-3">
        {" "}
        <Col xs={12} md={8} className="d-flex flex-wrap align-items-center">
          <div className="d-none d-md-flex flex-wrap align-items-center w-100 gap-2">
            <div className="flex-grow-1 min-w-150">
              <Form.Control
                type="text"
                value={searchLeadText}
                className="uniform-input search-text"
                placeholder="Search Here..."
                disabled={currentItems.length === 0 && !searchLeadText}
                onChange={handleSearchTextChange}
              />
            </div>

            <div style={{ minWidth: "150px" }}>
              <Form.Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                disabled={currentItems.length === 0 && !statusFilter}
                className="uniform-input"
              >
                <option value="">All Status</option>
                {STATUS_CHOICES.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </Form.Select>
            </div>

            {userPermissions.includes("lead_can_view_based_on_executive") && (
              <div style={{ minWidth: "180px" }}>
                <Form.Select
                  value={executiveFilter}
                  onChange={(e) => setExecutiveFilter(e.target.value)}
                  disabled={currentItems.length === 0 && !executiveFilter}
                  className="uniform-input"
                >
                  <option value="">— Select Executive —</option>
                  {executives.map((exec) => (
                    <option key={exec.id} value={exec.id}>
                      {exec.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            )}

            <div style={{ minWidth: "150px" }}>
              <Form.Select
                value={dateFilter}
                disabled={currentItems.length === 0 && !dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
                className="uniform-input"
              >
                <option value="">— Select Date —</option>
                {DATE_FILTER_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>

            {dateFilter === "customrange" && (
              <div className="d-flex gap-2" style={{ minWidth: "300px" }}>
                <input
                  type="date"
                  className="form-control common-input"
                  placeholder="Start Date"
                  onChange={(e) => setLeadFilterStartDate(e.target.value)}
                />
                <input
                  type="date"
                  className="form-control common-input"
                  placeholder="End Date"
                  onChange={(e) => setLeadFilterEndDate(e.target.value)}
                />
              </div>
            )}
          </div>

          <div className="d-md-none w-100">
            <Accordion flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Actions and Filters</Accordion.Header>
                <Accordion.Body>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control common-input"
                      value={searchLeadText}
                      placeholder="Search Here..."
                      disabled={currentItems.length === 0 && !searchLeadText}
                      onChange={handleSearchTextChange}
                    />
                  </div>

                  <div className="mb-3">
                    <select
                      className="form-control common-input"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      disabled={currentItems.length === 0 && !statusFilter}
                    >
                      <option value="">— Select Status —</option>
                      {STATUS_CHOICES.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {userPermissions.includes(
                    "lead_can_view_based_on_executive",
                  ) && (
                    <div className="mb-3">
                      <select
                        className="form-control common-input"
                        value={executiveFilter}
                        onChange={(e) => setExecutiveFilter(e.target.value)}
                      >
                        <option value="">— Select Executive —</option>
                        {executives.map((exec) => (
                          <option key={exec.id} value={exec.id}>
                            {exec.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="mb-3">
                    <select
                      className="form-control common-input"
                      value={dateFilter}
                      disabled={currentItems.length === 0 && !dateFilter}
                      onChange={(e) => setDateFilter(e.target.value)}
                    >
                      <option value="">— Select Date —</option>
                      {DATE_FILTER_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {dateFilter === "customrange" && (
                    <div className="d-flex justify-content-between gap-2">
                      <input
                        type="date"
                        className="form-control common-input"
                        placeholder="Start Date"
                        onChange={(e) => setLeadFilterStartDate(e.target.value)}
                      />
                      <input
                        type="date"
                        className="form-control common-input"
                        placeholder="End Date"
                        onChange={(e) => setLeadFilterEndDate(e.target.value)}
                      />
                    </div>
                  )}

                  <div className="d-flex flex-wrap gap-2 mt-3">
                    {userPermissions.includes("lead_add_lead") && (
                      <CommonButton
                        className="uniform-button d-flex align-items-center flex-fill"
                        onClick={handleApplyLead}
                      >
                        <FaPlus className="me-2" /> Add
                      </CommonButton>
                    )}

                    {userPermissions.includes("lead_can_import_lead") && (
                      <CommonButton
                        className="uniform-button d-flex align-items-center flex-fill"
                        onClick={() => setShowImportModal(true)}
                      >
                        <FaFileImport className="me-2" /> Import
                      </CommonButton>
                    )}

                    {userPermissions.includes("lead_can_export_lead") && (
                      <CommonButton
                        className="uniform-button d-flex align-items-center flex-fill"
                        onClick={() => setShowExportModal(true)}
                        disabled={currentItems.length === 0}
                      >
                        <FaFileExport className="me-2" /> Export
                      </CommonButton>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </Col>
        <Col
          xs={12}
          md={4}
          className="d-flex justify-content-md-end flex-wrap align-items-center gap-2"
        >
          <div className="d-none d-md-flex flex-wrap gap-2">
            {userPermissions.includes("lead_add_lead") && (
              <CommonButton
                className="uniform-button"
                onClick={handleApplyLead}
              >
                <FaPlus style={{ marginRight: "6px" }} /> Add
              </CommonButton>
            )}
            {userPermissions.includes("lead_can_import_lead") && (
              <CommonButton
                className="uniform-button"
                onClick={() => setShowImportModal(true)}
              >
                <FaFileImport style={{ marginRight: "6px" }} /> Import
              </CommonButton>
            )}
            {userPermissions.includes("lead_can_export_lead") && (
              <CommonButton
                className="uniform-button"
                onClick={() => setShowExportModal(true)}
                disabled={currentItems.length === 0}
              >
                <FaFileExport style={{ marginRight: "6px" }} /> Export
              </CommonButton>
            )}
          </div>
        </Col>
      </Row>

      <div
        className={`table-responsive ${
          currentItems.length === 0 ? "" : "tabell"
        } `}
        style={{ height: "64vh" }}
      >
        {loading ? (
          <Loader />
        ) : currentItems.length > 0 ? (
          <table className="table  tstart">
            <thead className="thead">
              <tr style={{ whiteSpace: "nowrap" }}>
                <th style={{ width: "250px" }}>{labels.customerName}</th>
                <th style={{ width: "250px" }}>{labels.companyName}</th>
                <th style={{ width: "150px" }}>Source</th>
                <th style={{ width: "200px" }}>Since</th>
                <th style={{ width: "150px" }}>Mobile No.</th>
                <th style={{ width: "250px" }}>Email</th>
                <th style={{ width: "250px" }}>Address</th>
                <th style={{ width: "250px" }}>Remark</th>
                <th style={{ width: "200px" }}>Next Update</th>
                <th style={{ width: "150px" }}>Lead Status</th>
                <th style={{ width: "150px" }}></th>
                <th style={{ width: "250px" }}></th>
              </tr>
            </thead>
            <tbody>
              {currentItems
                .sort((a, b) => {
                  if (
                    a.status === "Service Taken" &&
                    b.status !== "Service Taken"
                  )
                    return 1;
                  if (
                    a.status !== "Service Taken" &&
                    b.status === "Service Taken"
                  )
                    return -1;
                  return 0;
                })
                .map((lead, index) => (
                  <tr
                    key={lead.id}
                    onClick={() => handleViewLead(lead)}
                    className="tbody"
                  >
                    {/* <td>
          <div title={index + 1} className="tdsubject">
            {currentPage * itemsPerPage + index + 1}
          </div>
        </td> */}
                    <td>
                      <div
                        title={
                          lead.firstName && lead.lastName
                            ? `${lead.firstName} ${lead.lastName}`
                            : lead.firstName
                              ? lead.firstName
                              : lead.lastName
                                ? lead.lastName
                                : "Unknown Name"
                        }
                        className="d-flex align-items-center tdsubject"
                      >
                        <span className="badge bg-primary text-white me-2">
                          {lead.id}
                        </span>
                        <div className="tdsubject">
                          {lead.firstName && lead.lastName
                            ? `${lead.firstName} ${lead.lastName}`
                            : lead.firstName
                              ? lead.firstName
                              : lead.lastName
                                ? lead.lastName
                                : "—"}
                        </div>
                      </div>
                    </td>

                    <td>
                      <div
                        title={lead.companyName || "—"}
                        className="tdsubject"
                      >
                        {lead.companyName || "—"}
                      </div>
                    </td>
                    <td>
                      <div title={lead.source || "—"} className="tdsubject">
                        {lead.source || "—"}
                      </div>
                    </td>
                    <td>
                      <div title={lead.created_at || "—"} className="tdsubject">
                        {lead.created_at || "—"}
                      </div>
                    </td>
                    <td>
                      <div title={lead.mobile || "—"} className="tdsubject">
                        {lead.mobile || "—"}
                      </div>
                    </td>
                    <td>
                      <div title={lead.email || "—"} className="tdsubject">
                        {lead.email || "—"}
                      </div>
                    </td>
                    <td>
                      <div
                        title={
                          lead.address ||
                          lead.city ||
                          lead.state ||
                          lead.country
                            ? [
                                lead.address,
                                lead.city,
                                lead.state,
                                lead.country,
                              ]
                                .filter(Boolean)
                                .join(", ")
                            : "—"
                        }
                        className="tdsubject"
                      >
                        {lead.address || lead.city || lead.state || lead.country
                          ? [lead.address, lead.city, lead.state, lead.country]
                              .filter(Boolean)
                              .join(", ")
                          : "—"}
                      </div>
                    </td>
                    <td>
                      <div title={lead.notes || "—"} className="tdsubject">
                        {lead.notes || "—"}
                      </div>
                    </td>

                    <td>
                      <div
                        title={
                          lead.next_interaction
                            ? `${moment(lead.next_interaction).format(
                                "DD-MMM-YYYY HH:mm:ss",
                              )}`
                            : "—"
                        }
                        className="tdsubject"
                      >
                        {lead.next_interaction ? (
                          <>
                            <div>
                              {moment(lead.next_interaction).format(
                                "YYYY-MM-DD",
                              )}
                            </div>
                            <span className="badge bg-primary text-white">
                              {moment(lead.next_interaction).format("HH:mm:ss")}
                            </span>
                          </>
                        ) : (
                          "—"
                        )}
                      </div>
                    </td>
                    <td>
                      <span
                        style={{
                          backgroundColor:
                            STATUS_COLORS[lead.status] || "transparent",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        {lead.status || "—"}
                      </span>
                    </td>

                    <td>
                      <div className="d-flex align-items-center">
                        <a
                          href={`https://api.whatsapp.com/send/?phone=${encodeURIComponent(
                            `+91${lead.mobile}`,
                          )}&text=Hello`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-success me-2"
                        >
                          <IoLogoWhatsapp />
                        </a>
                        {userPermissions.includes("lead_change_lead") && (
                          <FaEdit
                            className="me-2 cursor-pointer text-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditLead(lead);
                            }}
                          />
                        )}

                        {userPermissions.includes("lead_delete_lead") && (
                          <FaTrashAlt
                            style={{
                              color: "#dc3545",
                              cursor: "pointer",
                              marginLeft: "5px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteLead(lead);
                            }}
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      {lead.status !== "Service Taken" && (
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUpdateStatus(lead);
                          }}
                          className="ms-2"
                        >
                          Update Status
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <NoData message="No Data Found" height="400px" />
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showImportModal && (
        <ImportModal
          show={showImportModal}
          handleClose={handleCloseModals}
          type="leads"
          onSuccess={() => {
            fetchLeadData(currentPage);
            fetchAllLeadData();
          }}
        />
      )}

      {showLeadModal && (
        <AddLeadModal
          show={showLeadModal}
          handleClose={handleCloseModals}
          fetchAllLeadData={fetchAllLeadData}
          leadData={editLeadData}
          fetchLeadData={() => fetchLeadData(currentPage)}
          isUpdateStatus={isUpdateStatus}
        />
      )}
      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="leads"
      />

      <LeadViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        fetchAllLeadData={fetchAllLeadData}
        lead={selectedLead}
        setLead={setSelectedLead}
        leadId={selectedLead?.id}
        fetchLeadData={() => fetchLeadData(currentPage)}
      />
    </div>
  );
};

export default LeadList;
